module.exports = __webpack_public_path__ + "html/404_40b3dccf48cc9be0aa1dc3722ecedba0.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/404.html
// module id = mWZi
// module chunks = 118